

import axiosInstance from '../../config';

// async funtion for make smoother and faster without waiting of acknowledgement
export const signupService =  async (data) => {


    try {
        const response = await axiosInstance.post('/v1/sign-up', data);
       
        return {
            status: response.status, //return status response
            data: response.data, //return data response
        };
    } 

    //for showing error message if something went wrong
    catch (error) {
        throw error.response.data || { message: "Something went wrong" };
    }



}

